// Accordion
jQuery(function ($) {
  $(document).accordion({
    heightStyle: 'content', header: '.toggler', active: !1, collapsible: !0, create: function (event, ui) {
      ui.header.addClass('active');
      $('.toggler').attr('tabindex', 0);
    }, activate: function (event, ui) {
      ui.newHeader.addClass('active');
      ui.oldHeader.removeClass('active');
      $('.toggler').attr('tabindex', 0);
    },
  });
});
